import React, { useState, useEffect } from "react";
import {
    fetchTakeTourBanner, fetchAllHospitalTourCategories, fetchAllHospitalTour,
    fetchTakeATourPageSeo
} from "../Adapter/PageAdapter";
import { baseImage_path } from "../variables/Variables";
import { stripHtmlForMeta } from "../utils/seoMetaText";
import opdBanner from "../assets/images/careerdetailban.jpg";
// import useSeo from "../hooks/useSeo";
// import SeoHelmet from "../components/SeoHelmet";
import { Helmet } from "react-helmet-async";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";

const TakeATourPage = () => {
    const [bannerData, setBannerData] = useState([]);
    const [categories, setCategories] = useState([]);
    const [tourImages, setTourImages] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    const [seoData, setSeoData] = useState(null);

    useEffect(() => {
        const loadSeo = async () => {
            try {
                console.log("Calling fetchTakeATourPageSeo...");
                const res = await fetchTakeATourPageSeo();
                console.log("API Response:", res);
                if (res && res.data) {
                    setSeoData(res.data);
                }
            } catch (e) {
                console.error("Direct SEO fetch failed:", e);
            }
        };

        loadSeo();
    }, []);

    // const seoData = useSeo(fetchTakeATourPageSeo);

    useEffect(() => {
        const fetchData = async () => {
            const bannerResponse = await fetchTakeTourBanner();
            if (bannerResponse && bannerResponse.data) {
                setBannerData(bannerResponse.data);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [categoriesRes, toursRes] = await Promise.all([
                    fetchAllHospitalTourCategories(),
                    fetchAllHospitalTour(),
                ]);

                if (categoriesRes?.data) {
                    setCategories(categoriesRes.data);
                    setSelectedCategory(categoriesRes.data[0]);
                }
                // if (toursRes?.data) {
                //     setTourImages(toursRes.data);
                // }
                if (toursRes?.data) {
                    const flattenedImages = [];

                    toursRes.data.forEach(tour => {
                        const imagePaths = typeof tour.image === 'string' && tour.image.trim() !== ''
                            ? tour.image.replace(/\[|\]|"|\\|\n/g, "").split(",")
                            : [];

                        imagePaths.forEach(imagePath => {
                            flattenedImages.push({
                                image: imagePath.trim(),
                                name: tour.name,
                                category_id: tour.category_id,
                            });
                        });
                    });

                    setTourImages(flattenedImages);
                }

            } catch (error) {
                console.error("Error fetching tour data:", error);
            }
        };

        fetchData();
    }, []);

    const filteredImages = tourImages.filter(tour => tour.category_id === selectedCategory?.id);

    return (
        <>
            {/* {seoData && <SeoHelmet seoData={seoData} />} */}
            {seoData && (
                <Helmet>
                    <title>{seoData.seo_title}</title>
                    <meta name="title" content={seoData.meta_title} />
                    <meta name="description" content={stripHtmlForMeta(seoData.meta_description)} />
                    <meta name="keywords" content={seoData.meta_keywords} />

                    <meta property="og:title" content={seoData.og_title} />
                    <meta property="og:description" content={stripHtmlForMeta(seoData.og_description)} />
                    <meta property="og:type" content={seoData.og_type} />
                    <meta property="og:url" content={seoData.og_url} />
                    <meta property="og:image" content={`${baseImage_path}/${seoData.og_image}`} />
                    <meta property="og:locale" content={seoData.og_locale} />
                    <meta property="og:site_name" content={seoData.og_site_name} />
                    <meta property="article:modified_time" content={seoData.article_modified_time} />

                    <meta name="twitter:card" content={seoData.twitter_card} />
                    <meta name="twitter:title" content={seoData.twitter_title} />
                    <meta name="twitter:description" content={stripHtmlForMeta(seoData.twitter_description)} />
                    <meta name="twitter:image" content={`${baseImage_path}/${seoData.twitter_image}`} />
                    <meta name="twitter:site" content={seoData.twitter_site} />

                    <link rel="canonical" href={seoData.canonical_link} />

                    {/* Custom scripts injection */}
                    {seoData.custom_scripts && (
                        <script type="text/javascript" dangerouslySetInnerHTML={{ __html: seoData.custom_scripts }} />
                    )}
                </Helmet>
            )}
            <section className="banner-spac">
                <div className="cust-container">
                    <div className="banner-box">
                        {bannerData && bannerData.img_path ? (
                            <img
                                src={`${baseImage_path}${bannerData.img_path.replace('.', '')}`}
                                alt={bannerData.banner_heading || "Take A Tour"}
                            />
                        ) : (
                            <img src={opdBanner} alt="Take A Tour" />
                        )}
                        <div className="ban-con">
                            <h1>{bannerData[0]?.banner_heading || 'Take A Tour'}</h1>
                        </div>
                    </div>
                </div>
            </section>

            <div className="tour-container" style={{ marginTop: '50px', marginBottom: '50px' }}>
                {/* Category Tabs */}
                <div className="tour-tabs" style={{ marginBottom: '40px' }}>
                    {categories.map(category => (
                        <button
                            key={category.id}
                            className={`tour-tab ${selectedCategory?.id === category.id ? "active" : ""}`}
                            onClick={() => setSelectedCategory(category)}
                        >
                            {category.category_name}
                        </button>
                    ))}
                </div>

                {/* Image Carousel */}
                <div className="tour-carousel">
                    {/* Main Image Swiper */}
                    <Swiper
                        spaceBetween={10}
                        slidesPerView={1}
                        loop={true}
                        navigation={{
                            nextEl: ".tour-slider-next",
                            prevEl: ".tour-slider-prev",
                        }}
                        thumbs={{ swiper: thumbsSwiper }}
                        modules={[Navigation, Thumbs]}
                        className="main-slider"
                    >
                        {filteredImages.map((image, index) => (
                            <SwiperSlide key={index}>
                                <img src={`${baseImage_path}/${image.image}`} alt={image.name} className="main-image" />
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    {/* Navigation Arrows */}
                    <div className="tour-slider-prev">&#10094;</div>
                    <div className="tour-slider-next">&#10095;</div>

                    {/* Thumbnails Swiper */}
                    <Swiper
                        onSwiper={setThumbsSwiper}
                        spaceBetween={20}
                        slidesPerView="auto"
                        // slidesPerView={Math.min(filteredImages.length, 2)}
                        // breakpoints={{
                        //     320: { slidesPerView: 2 },
                        //     768: { slidesPerView: 3 },
                        //     1024: { slidesPerView: 3 }
                        // }}
                        watchSlidesProgress
                        loop={true}
                        modules={[Thumbs]}
                        className="thumbs-slider"
                        style={{ marginTop: '30px' }}
                    >
                        {filteredImages.map((image, index) => (
                            <SwiperSlide key={index}>
                                <img src={`${baseImage_path}/${image.image}`} alt={image.name} className="thumb-image" />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </>
    );
};

export default TakeATourPage;
